import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import { colors } from "../config/colors";
import { FONT_SIZE_LG, FONT_WEIGHT_NORMAL } from "../config/styles";

const StyledEmptyState = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "64px 24px",
  minHeight: "400px",
  
  "& .empty-icon": {
    fontSize: "64px",
    color: colors.primary,
    marginBottom: "24px",
    "& svg": {
      width: "64px",
      height: "64px",
    },
  },
  
  "& .empty-title": {
    color: colors.custom,
    fontSize: "18px",
    fontWeight: 600,
    fontFamily: "DM Sans",
    marginBottom: "8px",
  },
  
  "& .empty-subtitle": {
    color: colors.nonActive,
    fontSize: FONT_SIZE_LG,
    fontWeight: FONT_WEIGHT_NORMAL,
    fontFamily: "DM Sans",
  },
});

/**
 * EmptyState Component
 * 
 * Displays a friendly empty state message when no data is available.
 * Can be used across tables, lists, and other data displays.
 * 
 * @param {string} message - The main message to display
 * @param {string} subtitle - Optional subtitle text
 * @param {node} icon - Optional icon component to display
 */
export const EmptyState = ({ message, subtitle, icon }) => {
  return (
    <StyledEmptyState>
      {icon && <div className="empty-icon">{icon}</div>}
      <Typography className="empty-title">{message}</Typography>
      {subtitle && <Typography className="empty-subtitle">{subtitle}</Typography>}
    </StyledEmptyState>
  );
};

EmptyState.propTypes = {
  message: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.node,
};

EmptyState.defaultProps = {
  subtitle: null,
  icon: null,
};